import { render, staticRenderFns } from "./ExternalWriting.vue?vue&type=template&id=341bebe6&scoped=true&"
import script from "./ExternalWriting.vue?vue&type=script&lang=js&"
export * from "./ExternalWriting.vue?vue&type=script&lang=js&"
import style0 from "./ExternalWriting.vue?vue&type=style&index=0&id=341bebe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341bebe6",
  null
  
)

export default component.exports